export const EditJobTemplateLineItemAction = ({ disabled, onClickSingle }) => ({
  label: "Edit",
  icon: "pen-to-square",
  iconStyle: "solid",
  disabled,
  onClickSingle,
})

export const RemoveJobTemplateLineItemAction = ({
  disabled,
  onClickSingle,
}) => ({
  label: "Remove",
  icon: "trash-can",
  iconStyle: "solid",
  danger: true,
  disabled,
  onClickSingle,
})
